import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import TextareaAutosize from "react-textarea-autosize";
import Form from "../../includes/Forms";
import Loading from 'react-fullscreen-loading';
import { format } from "date-fns";
import axios from 'axios';
import * as CONST from '../../includes/Constant';
import { toast } from 'react-toastify';
import { SD_INVOICE_STATUS, SD_MODE_OF_PAYMENT, S_FORMAT_CURRENCY_AND_AMOUNT, S_FORMAT_INR_CURRENCY_AND_AMOUNT, S_GET_CURRENCY_SYMBOL, S_GET_INVOICE_STATUS } from "../../includes/staticData";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Col, Row } from 'react-bootstrap';
import { Tooltip } from 'react-tooltip';

export default function InvoicePayments({ invoice_id, onClose, currentUser, invoiceStatus, selectedInvoice, invoiceCurrency }) {

  const [payments, setPayments] = useState([]);
  const [formData, setFormData] = useState({
    amount: "",
    exchange_rate: "",
    received_date: "",
    consider_date: "",
    transaction_id: "",
    mode: "",
    note: "",
    status: "",
    platform_fee: "",
    gst_amount: ""
  });

  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(false);
  /* Inline Editing */
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editAmount, setEditAmount] = useState("");
  const [editGstAmount, setEditGstAmount] = useState("");
  const [editPlatformFee, setEditPlatformFee] = useState("");
  const [editExRate, setEditExRate] = useState("");
  const [editDate, setEditDate] = useState("");
  const [editTransactionId, setEditTransactionId] = useState("");
  const [editMode, setEditMode] = useState("");
  const [editNote, setEditNote] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [editConsiderDate, setEditConsiderDate] = useState("");


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "status") {
      setLoading(true);
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (name === "status") {
      setLoading(false);
    }
  };

  const validateForm = async () => {
    let isValid = true;

    const { status, amount, received_date, consider_date, exchange_rate, transaction_id, mode, platform_fee, gst_amount } = formData;

    const ValidationFields = {
      status: {
        value: status,
        isRequired: true,
        label: "status",
      },
    };

    // For statuses "5", "2", "3": Require amount and date
    if (["5", "2", "3"].includes(status)) {
      ValidationFields.amount = {
        value: amount,
        isRequired: true,
        label: "amount",
      };

      ValidationFields.consider_date = {
        value: consider_date,
        isRequired: true,
        label: "date",
      };
    }

    // Only for status "2", "3": Require additional fields
    if (["2", "3"].includes(status)) {
      ValidationFields.exchange_rate = {
        value: exchange_rate,
        isRequired: true,
        label: "ex. rate",
      };
      ValidationFields.transaction_id = {
        value: transaction_id,
        isRequired: true,
        label: "txn id",
      };
      ValidationFields.mode = {
        value: mode,
        isRequired: true,
        label: "mode",
      };
      ValidationFields.platform_fee = {
        value: platform_fee,
        isRequired: true,
        label: "fee",
      };
      ValidationFields.received_date = {
        value: received_date,
        isRequired: true,
        label: "date",
      };
      if (selectedInvoice && selectedInvoice.currency === "INR") {
        ValidationFields.gst_amount = {
          value: gst_amount,
          isRequired: true,
          label: "gst amount",
        };
      }
    }

    let validator = Form.validator(ValidationFields);
    if (validator !== null) {
      setValidate({ validate: validator.errors });
      isValid = false;
    }
    return isValid;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validateForm();
    console.log(isValid);
    if (!isValid) return;
    setLoading(true);

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const mappedFormData = {
          amount: parseFloat(formData.amount || 0),
          received_date: formData.received_date
            ? format(formData.received_date, "dd/MM/yyyy")
            : "",
          transaction_id: formData.transaction_id,
          mode: formData.mode,
          note: formData.note,
          status: formData.status,
          exchange_rate: parseFloat(formData.exchange_rate || 0),
          platform_fee: parseFloat(formData.platform_fee || 0),
          gst_amount: parseFloat(formData.gst_amount || 0)
        };
        try {
          const response = await axios.post(CONST.ADD_INVOICE_PAYMENTS, {
            invoice_id,
            updated_by: currentUser,
            paymentData: mappedFormData,
            invoice_currency: selectedInvoice.currency || "INR",
            status: formData.status,
            consider_date: formData.consider_date
              ? format(formData.consider_date, "dd/MM/yyyy")
              : "",
          });

          if (response.data.status === "error") {
            toast.error(response.data.message);
          } else {
            fetchPayments();
            toast.success(response.data.message);
          }
        } catch (error) {
          toast.error("Something went wrong. Please try again.");
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const response = await axios.post(CONST.GET_INVOICE_PAYMENTS, {
        invoice_id: invoice_id,
      });
      if (response) {
        if (response.data.status === "success" && response.data.data.length > 0) {
          let ePayments = response.data.data;

          setPayments(ePayments);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  }
  const fetchTodaysExchangeRate = async () => {
    try {
      setLoading(true);
      const response = await axios.post(CONST.GET_TODAYS_EXCHANGE_LIST, {
        "from_currency": invoiceCurrency,
      });
      if (response) {
        if (response.data.status === "success") {
          let exRate = response.data.data;
          setFormData((prevData) => ({ ...prevData, exchange_rate: exRate }));
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  }
  useEffect(() => {
    fetchPayments();
    fetchTodaysExchangeRate();
  }, [])
  const handleInlineEdit = (index, payment) => {
    setEditingRowIndex(index);
    setEditAmount(payment.amount);
    setEditExRate(payment.exchange_rate);
    setEditPlatformFee(payment.platform_fee);
    setEditDate(payment.received_date ? new Date(payment.received_date) : "");
    setEditConsiderDate(payment.consider_date ? new Date(payment.consider_date) : "");
    setEditTransactionId(payment.transaction_id);
    setEditMode(payment.mode);
    setEditStatus(payment.status);
    setEditGstAmount(payment.gst_amount);
    setEditNote(payment.note);

  };

  const handleInlineSave = async (paymentId) => {
    const updatedData = {
      amount: parseFloat(editAmount || 0),
      exchange_rate: parseFloat(editExRate || 1),
      platform_fee: parseFloat(editPlatformFee || 0),
      received_date: editDate ? format(editDate, "dd/MM/yyyy") : "",
      transaction_id: editTransactionId,
      mode: editMode,
      note: editNote,
      status: editStatus
    };

    try {
      setLoading(true);
      const response = await axios.post(CONST.UPDATE_INVOICE_PAYMENTS, {
        invoice_id,
        updated_by: currentUser,
        paymentData: updatedData,
        payment_id: paymentId,
        consider_date: editConsiderDate ? format(editConsiderDate, "dd/MM/yyyy") : "",
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        fetchPayments();
        setEditingRowIndex(null);
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong");
    }
  };
  const handleDeletePayment = (paymentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this payment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await axios.post(CONST.DELETE_INVOICE_PAYMENT, {
            payment_id: paymentId,
            updated_by: currentUser,
          });

          if (response.data.status === "success") {
            toast.success(response.data.message);
            fetchPayments(); // refresh the payment list
          } else {
            toast.error(response.data.message);
          }
        } catch (err) {
          toast.error("Something went wrong while deleting payment");
        } finally {
          setLoading(false);
        }
      }
    });
  };
  return (
    <>
      {loading && <Loading loading={loading} />}
      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12}> <h5 className="card-title mb-2 ">Invoice Information</h5> </Col>
          <Col md={2} sm={6} lg={2} className='mb-1'>
            <label className="form-label text-muted">Invoice Number</label>
            <p>{selectedInvoice?.invoice_number || "-"}</p>
          </Col>
          <Col md={2} sm={6} lg={2} className='mb-1'>
            <label className="form-label text-muted">Invoice Amount </label>
            <p> {S_FORMAT_CURRENCY_AND_AMOUNT(selectedInvoice.currency || "INR", selectedInvoice?.total_amount || 0)} </p>
          </Col>
          {
            selectedInvoice.client && selectedInvoice.client.country !== 'IN' ? (
              <>
                <Col md={2} sm={6} lg={2} className='mb-1'>
                  <label className="form-label text-muted">Exchange Rate </label>
                  <p>{selectedInvoice?.exchange_rate || 1}</p>
                </Col>
                <Col md={2} sm={6} lg={2} className='mb-1'>
                  <label className="form-label text-muted">Invoice Amount ({S_GET_CURRENCY_SYMBOL("INR")}) </label>
                  <p>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(selectedInvoice?.total_amount_inr || 0)}</p>
                </Col>

              </>
            ) : (
              <>
                <Col md={2} sm={6} lg={2} className='mb-1'>
                  <label className="form-label text-muted">Gross ({S_GET_CURRENCY_SYMBOL("INR")}) </label>
                  <p>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(selectedInvoice?.total_gross_payment || 0)}</p>
                </Col>
                <Col md={2} sm={6} lg={2} className='mb-1'>
                  <label className="form-label text-muted">GST ({S_GET_CURRENCY_SYMBOL("INR")}) </label>
                  <p>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(selectedInvoice?.total_gst_amount || 0)}</p>
                </Col>
              </>
            )
          }
          <Col md={2} sm={6} lg={2} className='mb-1'>
            <label className="form-label text-muted">Status</label>
            <p>{S_GET_INVOICE_STATUS(selectedInvoice.status)}</p>
          </Col>
          <Col md={2} sm={6} lg={2} className='mb-1'>
            <label className="form-label text-muted">Internale Note:</label>
            <p>{selectedInvoice?.internal_note}</p>
          </Col>
        </Row>
        <hr />
        <div className="row">
          <Col xs={12}> <h5 className="card-title mb-2 ">Payment Information</h5> </Col>
          <Col md={3} sm={6} lg={2} className='mb-1'>
            <label className="form-label">Payment Status</label>
            <select
              name="status"
              className={`form-control ${validate?.validate?.status ? "is-invalid" : ""}`}
              value={formData.status}
              onChange={handleChange}
            >
              <option value="">Payment Status</option>
              {SD_INVOICE_STATUS.map((statusItem) => (
                <option key={statusItem.code} value={statusItem.code}>
                  {statusItem.name}
                </option>
              ))}
            </select>
            {validate?.validate?.status && (
              <div className="invalid-feedback">{validate.validate.status}</div>
            )}
          </Col>
          {
            formData.status && ["2", "3", "5"].includes(formData.status) && (
              <>
                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">
                    Gross Amount in <strong>({S_GET_CURRENCY_SYMBOL(selectedInvoice.currency || "INR")})</strong>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${validate?.validate?.amount ? "is-invalid" : ""}`}
                    placeholder="Amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                  />
                  {validate?.validate?.amount && (
                    <div className="invalid-feedback">{validate.validate.amount}</div>
                  )}
                </Col>
                {
                  formData.status && ["2", "3"].includes(formData.status) && (
                    <>
                      {selectedInvoice.currency && selectedInvoice.currency === "INR" ? (
                        <>
                          <Col md={3} sm={6} lg={2}>
                            <label className="form-label">
                              GST Amount in <strong>({S_GET_CURRENCY_SYMBOL(selectedInvoice.currency || "INR")})</strong>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${validate?.validate?.gst_amount ? "is-invalid" : ""}`}
                              placeholder="GST Amount"
                              name="gst_amount"
                              value={formData.gst_amount}
                              onChange={handleChange}
                            />
                            {validate?.validate?.gst_amount && (
                              <div className="invalid-feedback">{validate.validate.gst_amount}</div>
                            )}
                          </Col>
                        </>
                      ) : ("")
                      }

                    </>
                  )
                }
                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">Payment Consider Date
                    <Link
                      to="#"
                      className='ml-1'
                      data-tooltip-id="tooltip"
                      data-tooltip-content="It will consider payment in this month"
                    >
                      <i className="bx bx-info-circle"></i>
                    </Link>

                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={formData.consider_date}
                    onChange={(date) => setFormData((prev) => ({ ...prev, consider_date: date }))}
                    name="consider_date"
                    className={`form-control ${validate?.validate?.consider_date ? "is-invalid" : ""}`}
                    placeholderText="Consider Date"
                  />
                  {validate?.validate?.consider_date && (
                    <div className="invalid-feedback">{validate.validate.consider_date}</div>
                  )}
                </Col>
              </>
            )
          }
          {
            formData.status && !["4", "5", "0", "1"].includes(formData.status) && (
              <>
                {selectedInvoice.currency && selectedInvoice.currency !== "INR" ? (
                  <>
                    <Col md={3} sm={6} lg={2}>
                      <label className="form-label">Exchange Rate</label>
                      <input
                        type="text"
                        className={`form-control ${validate?.validate?.exchange_rate ? "is-invalid" : ""}`}
                        placeholder="Ex. Rate"
                        name="exchange_rate"
                        value={formData.exchange_rate}
                        onChange={handleChange}
                      />
                      {validate?.validate?.exchange_rate && (
                        <div className="invalid-feedback">{validate.validate.exchange_rate}</div>
                      )}
                    </Col>
                  </>
                ) : ("")
                }

                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">Transaction Date
                    <Link
                      to="#"
                      className='ml-1'
                      data-tooltip-id="tooltip"
                      data-tooltip-content="It will consider txn date in this month"
                    >
                      <i className="bx bx-info-circle"></i>
                    </Link>

                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={formData.received_date}
                    onChange={(date) => setFormData((prev) => ({ ...prev, received_date: date }))}
                    name="received_date"
                    className={`form-control ${validate?.validate?.received_date ? "is-invalid" : ""}`}
                    placeholderText="Transaction Date"
                  />
                  {validate?.validate?.received_date && (
                    <div className="invalid-feedback">{validate.validate.received_date}</div>
                  )}
                </Col>

                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">Platform Fee ({S_GET_CURRENCY_SYMBOL("INR")})</label>
                  <input
                    type="text"
                    className={`form-control ${validate?.validate?.platform_fee ? "is-invalid" : ""}`}
                    placeholder="Fee"
                    name="platform_fee"
                    value={formData.platform_fee}
                    onChange={handleChange}
                  />
                  {validate?.validate?.platform_fee && (
                    <div className="invalid-feedback">{validate.validate.platform_fee}</div>
                  )}
                </Col>
                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">Transaction ID</label>
                  <input
                    type="text"
                    className={`form-control ${validate?.validate?.transaction_id ? "is-invalid" : ""}`}
                    placeholder="Transaction ID"
                    name="transaction_id"
                    value={formData.transaction_id}
                    onChange={handleChange}
                  />
                  {validate?.validate?.transaction_id && (
                    <div className="invalid-feedback">{validate.validate.transaction_id}</div>
                  )}
                </Col>

                <Col md={3} sm={6} lg={2}>
                  <label className="form-label">Mode</label>
                  <select
                    className={`form-control ${validate?.validate?.mode ? "is-invalid" : ""}`}
                    name="mode"
                    value={formData.mode}
                    onChange={handleChange}
                  >
                    <option value="">Select Mode</option>
                    {SD_MODE_OF_PAYMENT.map((modeItem) => (
                      <option key={modeItem.code} value={modeItem.code}>
                        {modeItem.name}
                      </option>
                    ))}
                  </select>
                  {validate?.validate?.mode && (
                    <div className="invalid-feedback">{validate.validate.mode}</div>
                  )}
                </Col>
              </>
            )
          }

          <Col md={6}>
            <label className="form-label">Note</label>
            <TextareaAutosize
              className="form-control"
              placeholder="Please enter internal note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              minRows={2}
              maxRows={10}
              style={{ width: "100%", resize: "none" }}
            />
          </Col>
          <Col className="text-right mb-1 mt-2" >
            <button type="submit" className="btn btn-primary">
              <i className="bx bx-save"></i> Save
            </button>
          </Col>
        </div>
      </form >
      <hr className='py-2' />
      <div className='row'>
        <h4>Payments</h4>
        {
          payments && (
            <>
              <div className='col-12'>
                <table className="table table-striped table-bordered " style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Gross <br /> Amount ({S_GET_CURRENCY_SYMBOL(selectedInvoice.currency || "INR")})</th>
                      {
                        (selectedInvoice.currency === "INR") ? (
                          <>
                            <th>GST <br /> Amount ({S_GET_CURRENCY_SYMBOL("INR")})</th>
                          </>
                        ) :
                          (
                            <>
                              <th>Ex. Rate</th>
                            </>
                          )
                      }
                      <th>Fee</th>
                      <th>Total <br /> Received ({S_GET_CURRENCY_SYMBOL("INR")})</th>
                      <th>Payment<br /> Consider Date</th>
                      <th>Txn Date</th>
                      <th>Txn Id</th>
                      <th>Mode</th>
                      <th>Note</th>
                      <th>Status</th>
                      <th>Update By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map((payment, index) => {
                      const isEditing = editingRowIndex === index;
                      return (
                        <tr key={payment.id}>
                          <td className="text-nowrap text-right" >
                            {
                              isEditing ? (
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={editAmount}
                                  onChange={(e) => setEditAmount(e.target.value)}
                                />
                              ) : (
                                <>
                                  {S_FORMAT_CURRENCY_AND_AMOUNT(selectedInvoice.currency || "INR", payment.amount || 0)}

                                </>

                              )
                            }
                          </td>
                          {
                            (selectedInvoice.currency === "INR") ? (
                              <>
                                <td className='text-right'>
                                  {
                                    isEditing ? (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={editGstAmount}
                                        onChange={(e) => setEditGstAmount(e.target.value)}
                                      />
                                    ) : (
                                      <>
                                        {S_FORMAT_CURRENCY_AND_AMOUNT(selectedInvoice.currency || "INR", payment.gst_amount || 0)}
                                      </>

                                    )
                                  }
                                </td>
                              </>
                            ) :
                              (
                                <>
                                  <td className='text-right'>
                                    {
                                      isEditing ? (
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={editExRate}
                                          onChange={(e) => setEditExRate(e.target.value)}
                                        />
                                      ) : (
                                        <>
                                          {payment.exchange_rate || "1.0"}
                                        </>

                                      )
                                    }
                                  </td>
                                </>
                              )
                          }
                          <td className='text-right'>
                            {
                              isEditing ? (
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={editPlatformFee}
                                  onChange={(e) => setEditPlatformFee(e.target.value)}
                                />
                              ) : (
                                <>
                                  {S_FORMAT_INR_CURRENCY_AND_AMOUNT(payment.platform_fee || 0)}
                                </>

                              )
                            }
                          </td>
                          <td className="text-nowrap text-right" >
                            {S_FORMAT_INR_CURRENCY_AND_AMOUNT(payment.inr_amount || 0)}
                          </td>



                          <td className="text-nowrap text-center" >
                            {
                              isEditing ? (
                                <DatePicker
                                  dateFormat="dd/MM/yyyy"
                                  selected={editConsiderDate}
                                  onChange={(date) => setEditConsiderDate(date)}
                                  className="form-control form-control-sm"
                                />
                              ) : (
                                <>
                                  {
                                    payment.consider_date && (
                                      new Date(payment.consider_date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      }
                                      )
                                    )}

                                </>
                              )
                            }
                          </td>
                          <td className="text-nowrap text-center" >
                            {isEditing ? (
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={editDate}
                                onChange={(date) => setEditDate(date)}
                                className="form-control form-control-sm"
                              />
                            ) : (
                              <>
                                {
                                  payment.received_date && (
                                    new Date(payment.received_date).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                    )
                                  )}

                              </>

                            )}
                          </td>
                          <td className="text-nowrap text-center" >
                            {isEditing ? (
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={editTransactionId}
                                onChange={(e) => setEditTransactionId(e.target.value)}
                              />
                            ) : (
                              payment.transaction_id
                            )}
                          </td>
                          <td className="text-nowrap text-center" style={{ position: "relative", zIndex: 1000 }}>
                            {isEditing ? (
                              <select
                                className="form-control form-control-sm"
                                value={editMode}
                                onChange={(e) => setEditMode(e.target.value)}
                                style={{ position: 'relative', zIndex: 1001 }}
                              >
                                <option value="">Select</option>
                                {SD_MODE_OF_PAYMENT.map((mode) => (
                                  <option key={mode.code} value={mode.code}>
                                    {mode.name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              payment.mode
                            )}
                          </td>
                          <td className="text-wrap text-left" >
                            {isEditing ? (
                              <TextareaAutosize
                                className="form-control form-control-sm"
                                minRows={1}
                                maxRows={4}
                                value={editNote}
                                onChange={(e) => setEditNote(e.target.value)}
                              />
                            ) : (
                              payment.note
                            )}
                          </td>
                          <td className="text-nowrap text-center" style={{ position: "relative", zIndex: 1000 }}>
                            {isEditing ? (
                              <select
                                className="form-control form-control-sm"
                                value={editStatus}
                                onChange={(e) => setEditStatus(e.target.value)}
                                style={{ zIndex: 10, position: "relative" }}
                              >
                                <option value="">Select</option>
                                {SD_INVOICE_STATUS.map((status) => (
                                  <option key={status.code} value={status.code}>
                                    {status.name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              (() => {
                                const statusObj = SD_INVOICE_STATUS.find(
                                  (item) => item.code === payment.status
                                );
                                return statusObj ? (
                                  <span className={`badge ${statusObj.color}`}>{statusObj.name}</span>
                                ) : (
                                  <span className="badge bg-secondary">Unknown</span>
                                );
                              })()
                            )}
                          </td>

                          <td className="text-nowrap text-center" >
                            {payment.updated_by_name}
                          </td>
                          <td className="text-nowrap text-center" >
                            {isEditing ? (
                              <>
                                <button
                                  className="btn btn-success btn-sm me-1"
                                  onClick={() => handleInlineSave(payment.id)}
                                >
                                  Save
                                </button>
                                <button
                                  className="btn btn-secondary btn-sm me-1"
                                  onClick={() => setEditingRowIndex(null)}
                                >
                                  Cancel
                                </button>

                              </>
                            ) : (
                              <>

                                <Link to="#" className="action" onClick={() => handleInlineEdit(index, payment)}
                                >
                                  <i class='bx bx-pencil'></i>
                                </Link>

                                <Link to="#" className="action" onClick={() => handleDeletePayment(payment.id)}>
                                  <i class='bx bx-trash'></i>
                                </Link>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>


                </table>
              </div>
            </>
          )
        }
        <Tooltip id="tooltip" place="bottom" />
      </div>
    </>
  )
}
